import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateDeleteCommunity = async ({
  id,
  reason,
}: {
  id: string;
  reason: string;
}) => {
  return await axiosAuth.delete(`${GET_COMMUNITIES}/${id}?reason=${reason}`);
};

const useDeleteCommunityMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      reason: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeleteCommunity,
    ...queryParams,
  });

export default useDeleteCommunityMutation;
